import React, { useState, useContext } from 'react';
import api from '../api/client';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post(`/api/token/`, {
        username,
        password,
      });
      login(res.data.access, res.data.refresh);
      setLoading(false);
      toast.success('Login successful!');
      navigate('/dashboard');
    } catch (err) {
      setLoading(false);
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit} className="form">
        <div className="formHeader">
          <h2 className="title">Fractional Land Ownership</h2>
          <div className="subtitle">Delhi, India</div>
        </div>
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Mobile Number or Username"
          required
          className="input"
          aria-label="Username or Mobile Number"
        />
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          required
          className="input"
          aria-label="Password"
        />
        <button type="submit" className="submitButton" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <div className="terms">
          By logging in, you agree to our <a href="/terms">Terms</a> & <a href="/privacy">Privacy Policy</a>.
        </div>
        <div className="register">New user? <a href="/register">Create account</a></div>
      </form>
    </div>
  );
};

export default Login;
